// @ts-nocheck
/**
 * GuestGateContext — cờ "chế độ khách" mỏng, dùng chung.
 *
 * GuestCreatorHost bọc creator bằng provider này (isGuest=true + requireLogin).
 * Các component CHUNG (DownloadButtons, ShareModal) đọc context để tự KHÓA
 * hành động cần xác thực (tải/xuất/chia sẻ) → gọi requireLogin thay vì thực thi.
 *
 * Mặc định isGuest=false → không ảnh hưởng luồng user đã đăng nhập.
 */

import React, { createContext, useContext } from 'react';

interface GuestGateValue {
  isGuest: boolean;
  /** Mở nhắc đăng nhập cho 1 hành động (vd "tải xuống"). */
  requireLogin: (action?: string) => void;
}

const GuestGateContext = createContext<GuestGateValue>({
  isGuest: false,
  requireLogin: () => {},
});

export const GuestGateProvider: React.FC<{ value: GuestGateValue; children: React.ReactNode }> = ({ value, children }) => (
  <GuestGateContext.Provider value={value}>{children}</GuestGateContext.Provider>
);

export const useGuestGate = (): GuestGateValue => useContext(GuestGateContext);
